import { useState } from 'react';

interface FaqItemProps {
  question: string;
  answer: string;
}

export const FaqItem = ({ question, answer }: FaqItemProps) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="w-full border-b border-white/10">
      <button
        className="flex justify-between items-center w-full py-6 text-left cursor-pointer group"
        onClick={() => setIsOpen(!isOpen)}
        aria-expanded={isOpen}
      >
        <span className="text-white text-[18px] md:text-[19px] font-medium tracking-[-0.015em] flex-1 pr-6 leading-snug group-hover:text-[#F5B800] transition-colors duration-200">
          {question}
        </span>
        <span
          className={`shrink-0 w-7 h-7 flex items-center justify-center rounded-full border border-white/15 text-white/70 transition-all duration-300 ${
            isOpen ? 'rotate-45 bg-[#F5B800] border-[#F5B800] text-[#0D0A00]' : 'group-hover:border-white/40'
          }`}
        >
          <svg width="12" height="12" viewBox="0 0 16 16" fill="none">
            <path d="M8 3V13M3 8H13" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
          </svg>
        </span>
      </button>
      <div
        className="grid transition-[grid-template-rows] duration-300 ease-out"
        style={{ gridTemplateRows: isOpen ? '1fr' : '0fr' }}
      >
        <div className="overflow-hidden">
          <p className="text-[15.5px] text-white/55 leading-[1.65] pb-6 pr-10 max-w-[58ch]">
            {answer}
          </p>
        </div>
      </div>
    </div>
  );
};
